import DonationDeleteModal from '@/core/components/DonationDeleteModal/DonationDeleteModal';

export default DonationDeleteModal;
